/**
 * @copyright Copyright 2019 Epic Systems Corporation
 * @file getNumFailed selector
 * @author Roland Scott
 * @module epic-px\react-async-hook\src\internal\state\selectors\get-num-failed
 */

import { IAsyncState } from "../types";
import { isComplete } from "./is-complete";
import { getError } from "./get-error";

/**
 * Get the number of async operations that failed.
 * @param state The async state
 */
export function getNumFailed(state: IAsyncState): number {
	if (!state) {
		throw new Error("State not defined.");
	}
	const { ids, executions } = state;
	if (!ids) {
		return 0;
	}
	if (!executions) {
		return 0;
	}
	return ids.filter(id => isComplete(state, id) && typeof getError(state, id) !== "undefined").length;
}
